//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('externalApi', {
//        templateUrl: 'views/components/views/externalApi/externalApi.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'externalApiService', 'ttGridFactory', 'logisticService', 'ediExportService', function ($stateParams, stateService, translateService, modalService, externalApiService, ttGridFactory, logisticService, ediExportService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let externalApiKeyno = $stateParams.external_api_keyno;
//            let authMethodId = 0;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                externalApiKeyno: externalApiKeyno,
//                businessCoButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.businessco_no = '0' }
//                ],
//                ediDestinationButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.edi_destination_keyno = '0' }
//                ],
//                externalApiAuthMethodButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.external_api_auth_method = 'none' }
//                ],
//                edit: {
//                    external_api_keyno: '',
//                    external_api_name: '',
//                    external_api_auth_method: ''
//                },
//                selectListMethods: [],
//                selectListCompanies: [],
//                selectListEdiDestinations: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'external_api_log_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            vm.handleMethodChange = handleMethodChange;

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadEdit() {
//                vm.model.edit = (await externalApiService.getEdit({ external_api_keyno: externalApiKeyno }))[0];
//            }

//            async function loadMethods() {
//                vm.model.selectListMethods = await externalApiService.listMethods();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadEdiDestinations() {
//                vm.model.selectListEdiDestinations = await ediExportService.listEdiDestinations();
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3480,
//                    parameters: vm.model.edit
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            function handleMethodChange(value) {
//                authMethodId = value;

//                var findMethod = vm.model.selectListMethods.filter(function (item) {
//                    return item.item_id === authMethodId;
//                });

//                var authMethod;

//                if (findMethod.length > 0 && findMethod[0].item_name !== '') {
//                    authMethod = findMethod[0].item_name;
//                } else {
//                    authMethod = 'none';
//                }

//                vm.model.edit.external_api_auth_method = authMethod;
//            }

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                externalApiService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].error_code !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: response[0].error_title,
//                            message: response[0].error_message,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    externalApiService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].error_code !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].error_message,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadMethods();
//                loadCompanies();
//                loadEdiDestinations();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
